import { useEffect, useState } from 'react';

/**
 * Cold-start-aware loading indicator.
 *
 * Renders the usual "Loading…" text immediately, but if the load is still in
 * flight after {@link WAKE_THRESHOLD_MS} it swaps to a reassuring message that
 * explains the wait — Render's free/cheap instances cold-start (~30–60s) after
 * an idle period, and a silent multi-second spinner reads as "broken" to users.
 *
 * Drop-in replacement for the inline `<p>Loading…</p>` blocks scattered across
 * the pages.
 */
const WAKE_THRESHOLD_MS = 5_000;
const WAKE_MESSAGE = 'Waking up the server, this may take up to a minute…';

type SmartLoadingProps = {
  /** Text shown for the first {@link WAKE_THRESHOLD_MS}. */
  label?: string;
  /** Tailwind classes for the wrapper element. */
  className?: string;
};

export function SmartLoading({
  label = 'Loading…',
  className = 'text-sm text-muted-foreground',
}: SmartLoadingProps) {
  const [waking, setWaking] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setWaking(true), WAKE_THRESHOLD_MS);
    return () => clearTimeout(timer);
  }, []);

  return <p className={className}>{waking ? WAKE_MESSAGE : label}</p>;
}
